import React from "react";
import { Grid, Box, Typography, Container, Button } from "@mui/material";
import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";

const Bottom = () => {
  const { t, i18n } = useTranslation();
  return (
    <Grid
      container
      justify="space-around"
      spacing={8}
      sx={{ pb: 15, px: { md: 18, sm: 3 } }}
    >
      <Grid md={6} sm={12} item>
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            width: 1,
            p: 2,
            "&:hover": { backgroundColor: "#f5f5f5" },
            textAlign: "center",
          }}
        >
          <HashLink smooth to="/b2b#top">
            <Box sx={{ fontWeight: 600 }}>
              <span
                style={{
                  backgroundColor: "#f3756d",
                  padding: "5px",
                  paddingBottom: "3px",
                  borderRadius: "15px",
                  color: "white",
                  marginRight: "5px",
                }}
              >
                NEW
              </span>
              B2B {t("BusinessRequest")}{" "}
              <span
                style={{
                  color: "gray",
                  fontWeight: 100,
                  fontSize: "12px",
                }}
              >
                <span>{t("BusinessRequest2")}</span>
                <ArrowRightOutlinedIcon
                  sx={{ fontSize: "15px", position: "relative", top: "+3px" }}
                />
              </span>
            </Box>
          </HashLink>
        </Box>
      </Grid>
      <Grid md={6} sm={12} item>
        <HashLink smooth to="/faq#top">
          <Box
            sx={{
              backgroundColor: "#f5f5f5",
              width: 1,
              p: 2,
              "&:hover": { backgroundColor: "#f5f5f5" },
              textAlign: "center",
            }}
          >
            <Box sx={{ fontWeight: 600 }}>
              {t("faq_bottom")}{" "}
              <span
                style={{
                  color: "gray",
                  fontWeight: 100,
                  fontSize: "12px",
                }}
              >
                <span>{t("faq_bottom2")}</span>
                <ArrowRightOutlinedIcon
                  sx={{ fontSize: "15px", position: "relative", top: "+3px" }}
                />
              </span>
            </Box>
          </Box>
        </HashLink>
      </Grid>
    </Grid>
  );
};

export default Bottom;
